import { React } from '_core';
const MetricSignalTimeSeries = () => {
  return <>Render</>;
};

export default MetricSignalTimeSeries;
